
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[event]",
      function () {
        return require("private-next-pages/events/[event]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[event]"])
      });
    }
  